import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Registered but not yet an active subscriber — don't let them into the
  // app itself, only the waiting screen.
  if (user?.subscriptionStatus !== 'active') {
    return <Navigate to="/pending-approval" replace />;
  }

  return children;
}